import * as types from '../types.js';
import {apiSeo} from '@/request/api.js';
export default {
	//执行获取验证码操作
	[types.MAKE_INIT_SEO]:({commit,state})=>{
		return apiSeo({}).then(ob=>{
			if(ob.state==1001){
				commit(types.MAKE_SET_SEO,ob.data);
				return ob;
			}else{
				return {state:1002,message:'保存失败',data:[]};
			}
		}).catch(ob=>{
			return {state:1002,message:'保存失败',data:[]};
		});
	}
}


// WEBPACK FOOTER //
// ./src/store/asset/actions.js